// @ts-strict-ignore
import {Cohort} from 'common/query-builder/cohorts-query-builder/models/cohort';
import {isScdPropertyName} from 'common/report/util/properties';
import {RHSInputType} from 'common/widgets/rhs-panel/types';

// Recursively replace instances of blueprint variables
export const swapBlueprintVariable = (
  obj: Obj | any[],
  oldValueToReplace: string,
  newValue: string,
  scdPropEventMap: {[scdPropName: string]: string},
): void => {
  const keyValues = Object.entries(obj);
  // works for arrays and objects
  for (const [key, val] of keyValues) {
    if (val === oldValueToReplace) {
      obj[key] = newValue;

      if (newValue.startsWith(`$custom_event`) && !Array.isArray(obj) && obj?.type === `event`) {
        // TODO - stopgap solution to handle custom event inputs in the Feature Launch template
        // perform manual swaps if a user has selected a custom event
        obj.id = parseInt(newValue.split(`$custom_event:`)[1]);
        obj.type = `custom-event`;
        obj.customEventSet = true;
      } else if (!Array.isArray(obj) && obj.customEventSet) {
        // swap back to event if user has selected a non-custom event
        obj.id = null;
        obj.type = `event`;
        obj.customEventSet = false;
      }
      if (isScdPropertyName(newValue) && scdPropEventMap?.[newValue] && !Array.isArray(obj)) {
        obj.scdEvent = scdPropEventMap[newValue];
      }
    }
    if (val instanceof Object || val instanceof Array) {
      swapBlueprintVariable(val, oldValueToReplace, newValue, scdPropEventMap);
    }
  }
};

// This is currently pretty specific for the Feature Launch template,
// which is the only template to take in a date input so far
const _updateBlueprintCohortsDates = (bpConfig, replaced, value) => {
  Object.values(bpConfig.cohorts).forEach((cohort: Cohort) => {
    cohort.groups.forEach((group) => {
      group.filters.forEach((filter) => {
        const range = filter.customProperty.behavior?.dateRange;
        if (range && range.type === `since` && filter.customProperty.behavior.dateRange.from === replaced) {
          filter.customProperty.behavior.dateRange.from = value;
        }
      });
    });
  });
  return bpConfig;
};

export const updateBlueprintCohorts = (bpConfig, replaced, value, inputType) => {
  if (inputType === RHSInputType.Date) {
    bpConfig = _updateBlueprintCohortsDates(bpConfig, replaced, value);
  }

  if (inputType === RHSInputType.Event) {
    swapBlueprintVariable(bpConfig.cohorts, replaced, value, {});
  }

  Object.values(bpConfig.cohorts).forEach((cohort: Cohort) => {
    if (cohort?.name) {
      cohort.name = cohort.name.replace(replaced, value);
    }
  });

  return bpConfig;
};

// This is currently pretty specific for the Feature Launch template,
// which is the only template to take in a date input so far
export const swapFeatureLaunchDate = (card, replaced, value) => {
  const selectedDate = new Date(Date.parse(value));
  const plus30Days = new Date(Date.parse(value));
  plus30Days.setDate(selectedDate.getDate() + 30);
  const minus30Days = new Date(Date.parse(value));
  minus30Days.setDate(selectedDate.getDate() - 30);
  const dateSwap = [minus30Days, plus30Days];

  card.bookmark.params.sections?.time &&
    card.bookmark.params.sections.time.forEach((time) => {
      if (time.dateRangeType === `between`) {
        time.value = time.value.map((date, i) => {
          if (date === replaced) {
            return value;
          }
          return dateSwap[i].toISOString().split(`T`)[0];
        });
      } else if (time.dateRangeType === `since`) {
        time.value = [selectedDate.toISOString().split(`T`)[0]];
      }
    });
};
